export default "__VITE_ASSET__DZYkLlXU__"